import React, { useState, useEffect } from 'react'
import moment from 'moment-jalaali'
import { makeStyles } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import EditIcon from 'src/icons/EditIcon'
import MUIDataTable from 'mui-datatables'
import { useNavigate } from 'react-router-dom'
import { ThemeProvider } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { getMuiTheme } from '../../utils/TableStyle'
import { getDiscounts, deleteDiscount, downloadDiscounts } from '../../app/slices/discountSlice'
import muiDefaultOptions from '../../constants/muiTableOptions'

const useStyle = makeStyles((theme) => {
  return {
    linkButton: {
      marginBottom: 10,
    },
    status0: {
      color: theme.palette.primary.light,
    },
    status1: {
      color: theme.palette.secondary.light,
    },
    icons: {
      color: '#b2b6c0',
      transition: '0.2s',
      '&:hover': {
        color: '#f39994',
      },
    },
  }
})

export const DiscountList = () => {
  const classes = useStyle()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const discounts = useSelector((state) => state.discounts.list)
  const count = useSelector((state) => state.discounts.totalHits)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(muiDefaultOptions.rowsPerPage)

  useEffect(() => {
    dispatch(getDiscounts({
      after: page * rowsPerPage,
      first: rowsPerPage,
    }))
  }, [rowsPerPage, page])

  const handleDelete = (list) => {
    const data = list?.data?.map((item) => discounts[item.dataIndex].discountId)
    dispatch(deleteDiscount(data))
  }

  const handleEdit = (state) => navigate(`edit/${state.discountId}`, { state })

  const handleDownlaod = (url) => dispatch(downloadDiscounts(url))

  const COLUMNS = [
    {
      name: 'row',
      label: 'ردیف',
    },
    {
      name: 'name',
      label: 'نام تخفیف',
    },
    {
      name: 'maxUsedCount',
      label: 'تعداد',
    },
    {
      name: 'currentUsedCount',
      label: 'استفاده شده',
    },
    {
      name: 'discountPercent',
      label: 'درصد تخفیف',
      options: {
        customBodyRender: (value) => (`%${value}`),
      },
    },
    {
      name: 'isActive',
      label: 'وضعیت',
      options: {
        customBodyRender: (value) => (
          <p className={classes[`status${value ? 0 : 1}`]}>{value ? 'فعال' : 'غیر فعال'}</p>
        ),
      },
    },
    {
      name: 'createDate',
      label: 'تاریخ ایجاد',
      options: {
        customBodyRender: (value) => (value ? moment(value)?.format('jYYYY/jMM/jDD') : '--'),
      },
    },
    {
      name: 'lastUpdateDate',
      label: 'آخرین به روز رسانی',
      options: {
        customBodyRender: (value) => (value ? moment(value)?.format('jYYYY/jMM/jDD') : '--'),
      },
    },
    {
      name: 'code',
      label: 'کد تخفیف',
      options: {
        download: true,
        customBodyRenderLite: (dataIndex) => {
          const data = discounts[dataIndex]
          if (!data.code) {
            return (
              <Button
                onClick={() => handleDownlaod(data?.csvUrl)}
                variant="contained"
              >
                دانلود فایل تخفیف‌ها
              </Button>
            )
          }
          return data.code
        },
      },
    },
    {
      name: 'expiredDate',
      label: 'تاریخ انقضا',
      options: {
        customBodyRender: (value) => (value ? moment(value)?.format('jYYYY/jMM/jDD') : '--'),
      },
    },
    {
      name: '',
      label: '',
      options: {
        customBodyRenderLite: (index) => {
          const data = discounts[index]
          return (
            <IconButton onClick={() => handleEdit(data)}>
              {/* <CreateIcon /> */}
              <EditIcon className={classes.icons} />
            </IconButton>
          )
        },
      },
    },
  ]

  return (
    <ThemeProvider theme={getMuiTheme}>
      <MUIDataTable
        data={discounts}
        columns={COLUMNS}
        options={{
          ...muiDefaultOptions,

          rowsPerPage,
          page,
          count,

          serverSide: true,
          filter: false,
          print: false,
          download: false,
          search: false,

          rowHover: true,
          selectableRows: 'none',
          onRowsDelete: (selectedRows) => handleDelete(selectedRows),
          searchable: false,
          onTableChange: (action, state) => {
            switch (action) {
              case 'changePage': {
                setPage(state.page)
                break
              }
              case 'changeRowsPerPage': {
                setRowsPerPage(state.rowsPerPage)
                break
              }
              default: {
                return null
              }
            }
            return null
          },
        }}
      />
    </ThemeProvider>
  )
}

export default DiscountList
